import './calameo.scss';

// Mode façade : l'iframe Calaméo n'est créée qu'au clic, pour ne pas peser sur
// le LCP quand plusieurs catalogues cohabitent sur une même page. Chaque façade
// est initialisée indépendamment (plusieurs blocs possibles par page).
const facades = document.querySelectorAll('.calameo__facade[data-calameo-url]') as NodeListOf<HTMLButtonElement>;

facades?.forEach(facade => {
    if (facade.dataset.calameoInit) return;
    facade.dataset.calameoInit = 'true';

    const url = facade.dataset.calameoUrl;
    if (!url) return;

    facade.addEventListener('click', () => {
        const iframe = document.createElement('iframe');

        iframe.className = 'calameo__iframe';
        iframe.src = url;
        iframe.title = facade.dataset.calameoTitle ?? 'Catalogue Calaméo';
        iframe.allowFullscreen = true;
        iframe.setAttribute('allow', 'fullscreen');

        facade.replaceWith(iframe);
        iframe.focus();
    }, { once: true });
});
